import { render, staticRenderFns } from "./RewardDetailsPopup.vue?vue&type=template&id=5646b03a&scoped=true"
import script from "./RewardDetailsPopup.vue?vue&type=script&lang=js"
export * from "./RewardDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=5646b03a&prod&scoped=true&lang=css&external"
import style1 from "./RewardDetailsPopup.vue?vue&type=style&index=1&id=5646b03a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5646b03a",
  null
  
)

export default component.exports